// removed by extract-text-webpack-plugin
module.exports = {"patch-details-tile":"PatchDetailsTile__patch-details-tile___3mvYS","patch-tile-controls":"PatchDetailsTile__patch-tile-controls___1CEbZ"};


//////////////////
// WEBPACK FOOTER
// ./src/components/PatchDetailsTile/PatchDetailsTile.css
// module id = 348
// module chunks = 0